
import { DispolistId__get_unwrap as DispolistId__get_unwrap_1, FormState__setValidationResponse_5219762A, FormState__startLoading, BusinessUnitId as BusinessUnitId_1, FormState_get_empty, RequestedValue$1, FormKind as FormKind_1, DispolistId } from "../../Shared/Shared.js";
import { filter, append, map, ofArray, singleton, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { utcNow } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { Helper_toElement, ToolWithQuantityElement, Element$, ConsumableElement, Helper_elementId, Dispolist_$reflection, DispolistElement_$reflection, Dispolist as Dispolist_7 } from "../../Shared/Dispolist.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { getAccountSettings } from "../../Requests/Customer.js";
import { getResponsibleBusinessUnits } from "../../Requests/BusinessUnit.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { string_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { unwrapDispolistId } from "../../Shared/Helper.js";
import { map as map_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { DispolistId__get_unwrap } from "../../Shared/Shared.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { Cmd_ofEffect } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";

export const emptyDispolist = new Dispolist_7(new DispolistId("00000000-0000-0000-0000-000000000000"), "", "", empty(), undefined, undefined, utcNow(), utcNow(), false);

export function init(userData) {
    return [new State(new FormKind_1(0, []), new RequestedValue$1(1, [emptyDispolist]), FormState_get_empty(), new RequestedValue$1(0, []), userData, new RequestedValue$1(0, []), new RequestedValue$1(0, [])), Cmd_batch(ofArray([getAccountSettings((Item) => (new Msg(10, [Item])), (Item_1) => (new Msg(12, [Item_1]))), getResponsibleBusinessUnits((Item_2) => (new Msg(11, [Item_2])), (Item_3) => (new Msg(12, [Item_3]))), Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(DispolistElement_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), "/api/dispolists/tools", (Item_4) => (new Msg(8, [Item_4])), (Item_5) => (new Msg(12, [Item_5])))]))];
}

export function initEdit(dispolistId, userData) {
    return [new State(new FormKind_1(1, []), new RequestedValue$1(0, []), FormState_get_empty(), new RequestedValue$1(0, []), userData, new RequestedValue$1(0, []), new RequestedValue$1(0, [])), Cmd_batch(ofArray([Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), Dispolist_$reflection()));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), concat("/api/dispolists/", ...unwrapDispolistId(new DispolistId(dispolistId))), (Item) => (new Msg(6, [Item])), (Item_1) => (new Msg(12, [Item_1]))), Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_5;
        return ((url_5 = addPrefix(url_3), (refreshOn_1) => fetchWithDecoder(url_5, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
            const pr_1 = response_2.arrayBuffer();
            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(DispolistElement_$reflection())));
        }, refreshOn_1)))(true).then((_arg_1) => {
            const result_3 = _arg_1;
            return (result_3.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_3.fields[0]);
            })())) : (Promise.resolve(result_3.fields[0]));
        });
    })), "/api/dispolists/tools", (Item_2) => (new Msg(8, [Item_2])), (Item_3) => (new Msg(12, [Item_3]))), getAccountSettings((Item_4) => (new Msg(10, [Item_4])), (Item_5) => (new Msg(12, [Item_5]))), getResponsibleBusinessUnits((Item_6) => (new Msg(11, [Item_6])), (Item_7) => (new Msg(12, [Item_7])))]))];
}

export function update(msg, state) {
    let matchValue_7, dispolist_14, body_3, fullPath_2, fullPath;
    switch (msg.tag) {
        case 1: {
            const matchValue_1 = state.Dispolist;
            if (matchValue_1.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const dispolist_2 = matchValue_1.fields[0];
                return [new State(state.FormKind, new RequestedValue$1(1, [new Dispolist_7(dispolist_2.Id, dispolist_2.Name, msg.fields[0], dispolist_2.Elements, dispolist_2.BusinessUnitId, dispolist_2.BusinessUnitName, dispolist_2.CreatedAt, dispolist_2.UpdatedAt, dispolist_2.IsDeleted)]), state.FormState, state.Elements, state.UserData, state.BusinessUnits, state.AccountSettings), Cmd_none()];
            }
        }
        case 2: {
            const quantity = msg.fields[1];
            const matchValue_2 = state.Dispolist;
            if (matchValue_2.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const dispolist_4 = matchValue_2.fields[0];
                if (quantity == null) {
                    return [state, Cmd_none()];
                }
                else {
                    const quantity_1 = quantity;
                    return [new State(state.FormKind, new RequestedValue$1(1, [new Dispolist_7(dispolist_4.Id, dispolist_4.Name, dispolist_4.Description, map((element) => {
                        if (Helper_elementId(element) === msg.fields[0]) {
                            switch (element.tag) {
                                case 0: {
                                    const consumable = element.fields[0];
                                    return new Element$(0, [new ConsumableElement(consumable.ConsumableId, consumable.Id, consumable.DisplayName, consumable.Unit, quantity_1, consumable.Type)]);
                                }
                                case 1:
                                    return element;
                                default: {
                                    const toolWithQuantity = element.fields[0];
                                    return new Element$(2, [new ToolWithQuantityElement(toolWithQuantity.ToolId, toolWithQuantity.Id, toolWithQuantity.DisplayName, ~~quantity_1, toolWithQuantity.Type)]);
                                }
                            }
                        }
                        else {
                            return element;
                        }
                    }, dispolist_4.Elements), dispolist_4.BusinessUnitId, dispolist_4.BusinessUnitName, dispolist_4.CreatedAt, dispolist_4.UpdatedAt, dispolist_4.IsDeleted)]), state.FormState, state.Elements, state.UserData, state.BusinessUnits, state.AccountSettings), Cmd_none()];
                }
            }
        }
        case 4: {
            const matchValue_3 = state.Dispolist;
            if (matchValue_3.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const dispolist_6 = matchValue_3.fields[0];
                return [new State(state.FormKind, new RequestedValue$1(1, [new Dispolist_7(dispolist_6.Id, dispolist_6.Name, dispolist_6.Description, dispolist_6.Elements, map_1((businessUnit_1) => (new BusinessUnitId_1(parse(businessUnit_1.value.Id))), msg.fields[0]), dispolist_6.BusinessUnitName, dispolist_6.CreatedAt, dispolist_6.UpdatedAt, dispolist_6.IsDeleted)]), state.FormState, state.Elements, state.UserData, state.BusinessUnits, state.AccountSettings), Cmd_none()];
            }
        }
        case 3: {
            const matchValue_4 = state.Dispolist;
            if (matchValue_4.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const dispolist_8 = matchValue_4.fields[0];
                return [new State(state.FormKind, new RequestedValue$1(1, [new Dispolist_7(dispolist_8.Id, dispolist_8.Name, dispolist_8.Description, append(dispolist_8.Elements, map(Helper_toElement, msg.fields[0])), dispolist_8.BusinessUnitId, dispolist_8.BusinessUnitName, dispolist_8.CreatedAt, dispolist_8.UpdatedAt, dispolist_8.IsDeleted)]), state.FormState, state.Elements, state.UserData, state.BusinessUnits, state.AccountSettings), Cmd_none()];
            }
        }
        case 5: {
            const matchValue_5 = state.Dispolist;
            if (matchValue_5.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const dispolist_10 = matchValue_5.fields[0];
                return [new State(state.FormKind, new RequestedValue$1(1, [new Dispolist_7(dispolist_10.Id, dispolist_10.Name, dispolist_10.Description, filter((e) => !equals(e, msg.fields[0]), dispolist_10.Elements), dispolist_10.BusinessUnitId, dispolist_10.BusinessUnitName, dispolist_10.CreatedAt, dispolist_10.UpdatedAt, dispolist_10.IsDeleted)]), state.FormState, state.Elements, state.UserData, state.BusinessUnits, state.AccountSettings), Cmd_none()];
            }
        }
        case 6:
            return [new State(state.FormKind, new RequestedValue$1(1, [msg.fields[0]]), state.FormState, state.Elements, state.UserData, state.BusinessUnits, state.AccountSettings), Cmd_none()];
        case 7: {
            const matchValue_6 = state.Dispolist;
            if (matchValue_6.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const dispolist_12 = matchValue_6.fields[0];
                return [new State(state.FormKind, state.Dispolist, FormState__startLoading(state.FormState), state.Elements, state.UserData, state.BusinessUnits, state.AccountSettings), (matchValue_7 = state.FormKind, (matchValue_7.tag === 1) ? ((dispolist_14 = dispolist_12, (body_3 = toString(0, Auto_generateBoxedEncoder_437914C6(Dispolist_$reflection(), undefined, undefined, undefined)(dispolist_14)), Cmd_OfPromise_either((tupledArg_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_5;
                    return ((url_5 = addPrefix(tupledArg_1[0]), (refreshOn_1) => fetchWithDecoder(url_5, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg_1[1]])]), "application/json", (response_3) => {
                        const pr_1 = response_3.arrayBuffer();
                        return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), string_type));
                    }, refreshOn_1)))(true);
                })), [concat("/api/dispolists/", ...DispolistId__get_unwrap(dispolist_14.Id)), body_3], (Item_5) => (new Msg(9, [Item_5])), (Item_6) => (new Msg(12, [Item_6])))))) : ((matchValue_7.tag === 2) ? Cmd_none() : Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_2;
                    return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response_1) => {
                        const pr = response_1.arrayBuffer();
                        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                    }, refreshOn)))(true);
                })), ["/api/dispolists", toString(0, Auto_generateBoxedEncoder_437914C6(Dispolist_$reflection(), undefined, undefined, undefined)(dispolist_12))], (Item_3) => (new Msg(9, [Item_3])), (Item_4) => (new Msg(12, [Item_4])))))];
            }
        }
        case 9: {
            const response_5 = msg.fields[0];
            if (response_5.tag === 1) {
                return [new State(state.FormKind, state.Dispolist, FormState__setValidationResponse_5219762A(state.FormState, response_5.fields[0]), state.Elements, state.UserData, state.BusinessUnits, state.AccountSettings), Cmd_errorToast("validation.toast")];
            }
            else {
                const matchValue_8 = state.FormKind;
                switch (matchValue_8.tag) {
                    case 1: {
                        const matchValue_9 = state.Dispolist;
                        if (matchValue_9.tag === 0) {
                            return [state, Cmd_none()];
                        }
                        else {
                            return [state, Cmd_batch(ofArray([(fullPath_2 = concat("/inventory-lists/", ...DispolistId__get_unwrap_1(matchValue_9.fields[0].Id)), Cmd_ofEffect((_arg_1) => {
                                RouterModule_nav(singleton(fullPath_2), 1, 1);
                            })), Cmd_successToast("general.saved_successfully")]))];
                        }
                    }
                    default:
                        return [new State(state.FormKind, state.Dispolist, FormState_get_empty(), state.Elements, state.UserData, state.BusinessUnits, state.AccountSettings), Cmd_batch(ofArray([(fullPath = concat("/inventory-lists/", ...response_5.fields[0]), Cmd_ofEffect((_arg) => {
                            RouterModule_nav(singleton(fullPath), 1, 1);
                        })), Cmd_successToast("general.saved_successfully")]))];
                }
            }
        }
        case 8:
            return [new State(state.FormKind, state.Dispolist, state.FormState, new RequestedValue$1(1, [msg.fields[0]]), state.UserData, state.BusinessUnits, state.AccountSettings), Cmd_none()];
        case 10:
            return [new State(state.FormKind, state.Dispolist, state.FormState, state.Elements, state.UserData, state.BusinessUnits, new RequestedValue$1(1, [msg.fields[0]])), Cmd_none()];
        case 11:
            return [new State(state.FormKind, state.Dispolist, state.FormState, state.Elements, state.UserData, new RequestedValue$1(1, [msg.fields[0]]), state.AccountSettings), Cmd_none()];
        case 12:
            return [new State(state.FormKind, state.Dispolist, FormState_get_empty(), state.Elements, state.UserData, state.BusinessUnits, state.AccountSettings), Cmd_none()];
        default: {
            const matchValue = state.Dispolist;
            if (matchValue.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const dispolist = matchValue.fields[0];
                return [new State(state.FormKind, new RequestedValue$1(1, [new Dispolist_7(dispolist.Id, msg.fields[0], dispolist.Description, dispolist.Elements, dispolist.BusinessUnitId, dispolist.BusinessUnitName, dispolist.CreatedAt, dispolist.UpdatedAt, dispolist.IsDeleted)]), state.FormState, state.Elements, state.UserData, state.BusinessUnits, state.AccountSettings), Cmd_none()];
            }
        }
    }
}

